import React from "react";
import Modal from "react-modal";
import moment from "moment";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/CloseIcon.svg";
import { ReactComponent as EmptyAssessments } from "../../../../assets/images/EmptyAssessments.svg";

import RiskPill from "../../../common/RiskPill";
import { NoAssessments } from "../InfoTabs/FlaggedJournals";
import { assessmentNameLookup } from "../../../../constants/constants";
const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    width: "75%",
  },
};

const InfoCard = ({ label, children }) => {
  return (
    <div>
      <strong style={{ display: "block", paddingBottom: "5px" }}>
        <label>{label}</label>
      </strong>
      {children}
    </div>
  );
};

const QuestionTab = ({ sno, question, answer, score, oneIndexed = false }) => {
  return (
    <div className="d-flex justify-content-between question-tab">
      <div className="question-sno">Q{oneIndexed ? sno : sno + 1}</div>
      <div className="question-main">
        <label style={{ fontSize: "100%" }}>{question?.text}</label>
        <span className="muted-text">{answer.text}</span>
      </div>
      <div className="question-score">{score}</div>
    </div>
  );
};

const SingleAssessmentModal = (props) => {
  Modal.setAppElement("#root");
  const {
    modalIsOpen,
    setModalOpen,
    assessment,
    assessmentName,
    flag = "urgent",
  } = props;
  const determineFlagColor = (custom_flag = flag) => {
    if (custom_flag.includes("moderate") && custom_flag.includes("severe")) {
      return "urgent";
    } else if (custom_flag.includes("severe")) {
      return "urgent";
    } else if (custom_flag.includes("moderate")) {
      return "medium";
    } else if (custom_flag.includes("low")) {
      return "low";
    } else {
      return "not on file";
    }
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel=""
        ariaHideApp={false}
      >
        <div
          className="container-fluid"
          style={{ margin: "0px", padding: "2.5%" }}
        >
          <button
            style={{
              position: "absolute",
              right: "15px",
              border: "0px",
              fontFamily: "DM Sans",
              backgroundColor: "transparent",
            }}
            onClick={closeModal}
          >
            <CloseIcon />
          </button>
          <CardLayout className="p-3">
            <div className="w-100 py-2 d-flex">
              <h3 className="primary-text-blue">
                {assessmentNameLookup[assessmentName?.toLowerCase()] ||
                  assessmentName}
              </h3>
            </div>
            <div className="info-card-container">
              <InfoCard label={"Test Taken"}>
                <span style={{ fontSize: "1.4rem", width: "100%" }}>
                  {moment(assessment?.created).format("Do MMM, YYYY")}
                </span>
              </InfoCard>
              <InfoCard label={"Score"}>
                <span style={{ fontSize: "1.4rem", width: "100%" }}>
                  {assessment?.score}
                </span>
              </InfoCard>
              <InfoCard label={"Tag"}>
                <RiskPill
                  type={determineFlagColor(assessment?.label || flag)}
                  custom_text={assessment?.label || flag}
                  show_icon={false}
                />
              </InfoCard>
            </div>
            <div
              className="container-fluid"
              style={{
                margin: "0px",
                padding: "0px",
                overflowY: "scroll",
                height: "50vh",
              }}
            >
              {assessment?.answers &&
                [...assessment.answers]
                  .sort(
                    (a, b) => (a.question?.sort ?? 0) - (b.question?.sort ?? 0)
                  )
                  .map((item) => {
                    return (
                      <QuestionTab
                        question={item?.question}
                        answer={item?.answer}
                        key={item.question.id}
                        score={item?.answer?.score}
                        sno={item.question?.sort}
                      />
                    );
                  })}
              {assessment === undefined && (
                <NoAssessments
                  text="No Data for this assessment"
                  link_text="Back to Assessments"
                  callback={() => {
                    closeModal();
                  }}
                />
              )}
            </div>
          </CardLayout>
        </div>
      </Modal>
    </div>
  );
};

export default SingleAssessmentModal;
